import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'success' | 'error' | 'warning' | 'ember';

const TONES: Record<BadgeTone, { background: string; color: string }> = {
  neutral: { background: 'var(--surface-tint)', color: 'var(--text-secondary)' },
  success: { background: 'var(--success-bg)', color: 'var(--success)' },
  error: { background: 'var(--error-bg)', color: 'var(--error)' },
  warning: { background: 'var(--warning-bg)', color: 'var(--warning)' },
  ember: { background: '#fdece0', color: 'var(--ember-dark)' },
};

export function Badge({ tone = 'neutral', children }: { tone?: BadgeTone; children?: ReactNode }) {
  return (
    <span
      style={{
        fontFamily: 'var(--font-vi)',
        fontSize: 'var(--text-caption)',
        fontWeight: 600,
        padding: '4px 10px',
        borderRadius: 'var(--radius-pill)',
        display: 'inline-block',
        lineHeight: 1.4,
        ...TONES[tone],
      }}
    >
      {children}
    </span>
  );
}
